/*eslint no-unreachable: "off"*/
/*eslint no-useless-concat: "off"*/
/*eslint no-array-constructor: "off"*/
/*eslint no-unused-vars: "off"*/

export function insertComma(n) {
  var reg = /(^[+-]?\d+)(\d{3})/; // 정규식
  n += "";
  while (reg.test(n))
    n = n.replace(reg, '$1' + "," + '$2');
  return n;
}
function chartColor(displayName) {
  if (displayName.indexOf('32') !== -1) return "#41b2e6";
  else if (displayName.indexOf('94') !== -1) return "#4452a8";
  else if (displayName.indexOf('44') !== -1) return "#fabc05";
  else if (displayName.indexOf('85') !== -1) return "#5587a2";
  else if (displayName.indexOf('49') !== -1) return "#69cabc";
  else if (displayName.indexOf('92') !== -1) return "#6c4a85";
  else if (displayName.indexOf('42') !== -1) return "#8a7860";
  else if (displayName.indexOf('41') !== -1) return "#96d4df";
  else if (displayName.indexOf('21') !== -1) return "#f7a33b";
  else if (displayName.indexOf('CMFL') !== -1) return "#d8c6aa";
  else if (displayName.indexOf('OTHER') !== -1) return "#999999";

  else if (displayName.indexOf('2G LG') !== -1) return "#41b2e6";
  else if (displayName.indexOf('3G LG') !== -1) return "#4452a8";
  else if (displayName.indexOf('LTE LG') !== -1) return "#fabc05";
  else if (displayName.indexOf('5G LG') !== -1) return "#acacac";

  else if (displayName.indexOf('2G KT') !== -1) return "#5587a2";
  else if (displayName.indexOf('3G KT') !== -1) return "#69cabc";
  else if (displayName.indexOf('LTE KT') !== -1) return "#6c4a85";
  else if (displayName.indexOf('5G KT') !== -1) return "#acacac";

  else if (displayName.indexOf('2G SK') !== -1) return "#8a7860";
  else if (displayName.indexOf('3G SK') !== -1) return "#96d4df";
  else if (displayName.indexOf('LTE SK') !== -1) return "#f7a33b";
  else if (displayName.indexOf('5G SK') !== -1) return "#acacac";

  else if (displayName.indexOf('2G 어린이') !== -1) return "#41b2e6";
  else if (displayName.indexOf('3G 어린이') !== -1) return "#4452a8";
  else if (displayName.indexOf('LTE 어린이') !== -1) return "#fabc05";
  else if (displayName.indexOf('5G 어린이') !== -1) return "#acacac";

  else if (displayName.indexOf('2G 경제인구') !== -1) return "#5587a2";
  else if (displayName.indexOf('3G 경제인구') !== -1) return "#69cabc";
  else if (displayName.indexOf('LTE 경제인구') !== -1) return "#6c4a85";
  else if (displayName.indexOf('5G 경제인구') !== -1) return "#acacac";

  else if (displayName.indexOf('2G 노년') !== -1) return "#8a7860";
  else if (displayName.indexOf('3G 노년') !== -1) return "#96d4df";
  else if (displayName.indexOf('LTE 노년') !== -1) return "#f7a33b";
  else if (displayName.indexOf('5G 노년') !== -1) return "#acacac";

  else if (displayName.indexOf('2G') !== -1) return "#41b2e6";
  else if (displayName.indexOf('3G') !== -1) return "#4452a8";
  else if (displayName.indexOf('LTE') !== -1) return "#fabc05";
  else if (displayName.indexOf('5G') !== -1) return "#acacac";

  else if (displayName.indexOf('TBD') !== -1) return "#41b2e6";
  else if (displayName.indexOf('공업지역') !== -1) return "#4452a8";
  else if (displayName.indexOf('관리지역') !== -1) return "#fabc05";
  else if (displayName.indexOf('녹지지역') !== -1) return "#5587a2";
  else if (displayName.indexOf('농림지역') !== -1) return "#69cabc";
  else if (displayName.indexOf('상업지역') !== -1) return "#6c4a85";
  else if (displayName.indexOf('자연환경보전지역') !== -1) return "#8a7860";
  else if (displayName.indexOf('주거지역') !== -1) return "#96d4df";
  else if (displayName.indexOf('어린이') !== -1) return "#20ccc1";
  else if (displayName.indexOf('경제인구') !== -1) return "#5587a2";
  else if (displayName.indexOf('노년') !== -1) return "#f6a44c";
  else return "#cccccc";
}

// chart1 데이터 생성 리턴 값 : {} chartBaseData
export function dataSettingByShare (dataList, _admin, _gubun_code, prm_check, prm_check2) {
  let chkCount = 1; // 무슨 의미?

  let chartBaseData = {
    // id: "chart1",
    // realId: "chartHolder1",
    title: "지역별서비스별 무선국 점유율222(%)",
    xtitle: "점유율(%)",
    ytitle: "지역명",
    chartType: "Multi Series Stacked Bar",
    layOutStyle: "Detail",
    masterName: "무선국 점유율",
    layOut: "",
    Data: [],
    Data2: [],
    valueFixed: 5,
    _admin: _admin,
  };
  if (_gubun_code === 'service'){
    chartBaseData.title = "지역별 서비스별 무선국 점유율333(%)";
    chkCount = prm_check.length;
  }else {
    chartBaseData.title = "지역별 국종별 무선국 점유율444(%)";
    chkCount = prm_check2.length;
  }

  // eslint-disable-next-line no-unused-vars
  let tmpData = dataList; // item
  let _tot_cnt = 0; // 무선국 수 합계
  // eslint-disable-next-line no-unused-vars
  let _tot_popltn = 0;
  // eslint-disable-next-line no-unused-vars
  let _tot_cnt2 = 0; // 인구유형별서비스별 인구밀도에 따른 무선국 수 합
  let _tot_area_size = 0; // 조회대상 총 면적

  let _max_cnt = 0;

  let check_column = "";
  let data2 = [];

  for (let i = 0; i < dataList.length; ++i) {
    let item = dataList[i];
    switch (item.DATA_TYPE) {
      case 'DATA_TYPE2' : // 지역별서비스별(국종별) 무선국 수
        let firstTmpData = {};
        firstTmpData.DATA_FIELD = item.DATA_FIELD;
        firstTmpData.DATA_COLUMN = item.DATA_COLUMN;
        firstTmpData.DATA_SUM = Number(item.DATA_SUM).toFixed(2);
        firstTmpData.DATA_SUM_str = insertComma(item.DATA_SUM);
        _tot_cnt += Number(item.DATA_SUM);

        if (_max_cnt < Number(item.DATA_SUM)) _max_cnt = Number(item.DATA_SUM);

        firstTmpData.DATA_2G = item.DATA_2G;
        firstTmpData.DATA_2G_str = insertComma(item.DATA_2G);
        firstTmpData.DATA_3G = item.DATA_3G;
        firstTmpData.DATA_3G_str = insertComma(item.DATA_3G);
        firstTmpData.DATA_LTE = item.DATA_LTE;
        firstTmpData.DATA_LTE_str = insertComma(item.DATA_LTE);
        firstTmpData.DATA_5G = item.DATA_5G;
        firstTmpData.DATA_5G_str = insertComma(item.DATA_5G);
        if (_gubun_code === "service") {
          if (_admin === 'Y') {
            firstTmpData.DATA_2G_LG = item.DATA_2G_LG;
            firstTmpData.DATA_2G_LG_str = insertComma(item.DATA_2G_LG);
            firstTmpData.DATA_3G_LG = item.DATA_3G_LG;
            firstTmpData.DATA_3G_LG_str = insertComma(item.DATA_3G_LG);
            firstTmpData.DATA_LTE_LG = item.DATA_LTE_LG;
            firstTmpData.DATA_LTE_LG_str = insertComma(item.DATA_LTE_LG);
            firstTmpData.DATA_5G_LG = item.DATA_5G_LG;
            firstTmpData.DATA_5G_LG_str = insertComma(item.DATA_5G_LG);

            firstTmpData.DATA_2G_KT = item.DATA_2G_KT;
            firstTmpData.DATA_2G_KT_str = insertComma(item.DATA_2G_KT);
            firstTmpData.DATA_3G_KT = item.DATA_3G_KT;
            firstTmpData.DATA_3G_KT_str = insertComma(item.DATA_3G_KT);
            firstTmpData.DATA_LTE_KT = item.DATA_LTE_KT;
            firstTmpData.DATA_LTE_KT_str = insertComma(item.DATA_LTE_KT);
            firstTmpData.DATA_5G_KT = item.DATA_5G_KT;
            firstTmpData.DATA_5G_KT_str = insertComma(item.DATA_5G_KT);

            firstTmpData.DATA_2G_SK = item.DATA_2G_SK;
            firstTmpData.DATA_2G_SK_str = insertComma(item.DATA_2G_SK);
            firstTmpData.DATA_3G_SK = item.DATA_3G_SK;
            firstTmpData.DATA_3G_SK_str = insertComma(item.DATA_3G_SK);
            firstTmpData.DATA_LTE_SK = item.DATA_LTE_SK;
            firstTmpData.DATA_LTE_SK_str = insertComma(item.DATA_LTE_SK);
          }
        } else {
          firstTmpData.DATA_32 = item.DATA_32;
          firstTmpData.DATA_32_str = insertComma(item.DATA_32);
          firstTmpData.DATA_94 = item.DATA_94;
          firstTmpData.DATA_94_str = insertComma(item.DATA_94);
          firstTmpData.DATA_44 = item.DATA_44;
          firstTmpData.DATA_44_str = insertComma(item.DATA_44);
          firstTmpData.DATA_85 = item.DATA_85;
          firstTmpData.DATA_85_str = insertComma(item.DATA_85);
          firstTmpData.DATA_49 = item.DATA_49;
          firstTmpData.DATA_49_str = insertComma(item.DATA_49);
          firstTmpData.DATA_92 = item.DATA_92;
          firstTmpData.DATA_92_str = insertComma(item.DATA_92);
          firstTmpData.DATA_42 = item.DATA_42;
          firstTmpData.DATA_42_str = insertComma(item.DATA_42);
          firstTmpData.DATA_41 = item.DATA_41;
          firstTmpData.DATA_41_str = insertComma(item.DATA_41);
          firstTmpData.DATA_21 = item.DATA_21;
          firstTmpData.DATA_21_str = insertComma(item.DATA_21);
          firstTmpData.DATA_CMFL = item.DATA_CMFL;
          firstTmpData.DATA_CMFL_str = insertComma(item.DATA_CMFL);
          firstTmpData.DATA_OTHER = item.DATA_OTHER;
          firstTmpData.DATA_OTHER_str = insertComma(item.DATA_OTHER);
        }
        data2.push(firstTmpData);
        break;
      case 'DATA_TYPE4' : // 지역전체면적
        _tot_area_size = Number(item.DATA_SUM);
        break;
      // no default
    }
  }

  if (data2.length > 0) {
    let tmpData2Ary = [];

    for (let i = 0; i < data2.length; i++) {
      let item = data2[i];
      let tmpData = {};
      let tmpData2 = {};

      if (_gubun_code === "service") {
        if (_admin === 'Y') {
          tmpData2.DATA_FIELD = item.DATA_FIELD + " 2G LG";
          tmpData2.DATA_SUM = item.DATA_2G_LG;
          tmpData2.DATA_SUM_str = item.DATA_2G_LG_str;
          tmpData2Ary.push(tmpData2);

          tmpData2.DATA_FIELD = item.DATA_FIELD + " 2G KT";
          tmpData2.DATA_SUM = item.DATA_2G_KT;
          tmpData2.DATA_SUM_str = item.DATA_2G_KT_str;
          tmpData2Ary.push(tmpData2);

          tmpData2.DATA_FIELD = item.DATA_FIELD + " 2G SK";
          tmpData2.DATA_SUM = item.DATA_2G_SK;
          tmpData2.DATA_SUMT_str = item.DATA_2G_SKT_str;
          tmpData2Ary.push(tmpData2);

          tmpData2.DATA_FIELD = item.DATA_FIELD + " 3G LG";
          tmpData2.DATA_SUM = item.DATA_3G_LG;
          tmpData2.DATA_SUM_str = item.DATA_3G_LG_str;
          tmpData2Ary.push(tmpData2);

          tmpData2.DATA_FIELD = item.DATA_FIELD + " 3G KT";
          tmpData2.DATA_SUM = item.DATA_3G_KT;
          tmpData2.DATA_SUM_str = item.DATA_3G_KT_str;
          tmpData2Ary.push(tmpData2);

          tmpData2.DATA_FIELD = item.DATA_FIELD + " 3G SK";
          tmpData2.DATA_SUM = item.DATA_3G_SK;
          tmpData2.DATA_SUM_str = item.DATA_3G_SK_str;
          tmpData2Ary.push(tmpData2);

          tmpData2.DATA_FIELD = item.DATA_FIELD + " LTE LG";
          tmpData2.DATA_SUM = item.DATA_LTE_LG;
          tmpData2.DATA_SUM_str = item.DATA_LTE_LG_str;
          tmpData2Ary.push(tmpData2);

          tmpData2.DATA_FIELD = item.DATA_FIELD + " LTE KT";
          tmpData2.DATA_SUM = item.DATA_LTE_KT;
          tmpData2.DATA_SUM_str = item.DATA_LTE_KT_str;
          tmpData2Ary.push(tmpData2);

          tmpData2.DATA_FIELD = item.DATA_FIELD + " LTE SK";
          tmpData2.DATA_SUM = item.DATA_LTE_SK;
          tmpData2.DATA_SUM_str = item.DATA_LTE_SK_str;
          tmpData2Ary.push(tmpData2);



          tmpData2.DATA_FIELD = item.DATA_FIELD + " 5G LG";
          tmpData2.DATA_SUM = item.DATA_5G_LG;
          tmpData2.DATA_SUM_str = item.DATA_5G_LG_str;
          tmpData2Ary.push(tmpData2);

          tmpData2.DATA_FIELD = item.DATA_FIELD + " 5G KT";
          tmpData2.DATA_SUM = item.DATA_5G_KT;
          tmpData2.DATA_SUM_str = item.DATA_5G_KT_str;
          tmpData2Ary.push(tmpData2);

          tmpData2.DATA_FIELD = item.DATA_FIELD + " 5G SK";
          tmpData2.DATA_SUM = item.DATA_5G_SK;
          tmpData2.DATA_SUM_str = item.DATA_5G_SK_str;
          tmpData2Ary.push(tmpData2);

        } else {
          tmpData2.DATA_FIELD = item.DATA_FIELD + " 2G";
          tmpData2.DATA_SUM = item.DATA_2G;
          tmpData2.DATA_SUM_str = item.DATA_2G_str;
          tmpData2Ary.push(tmpData2);

          tmpData2.DATA_FIELD = item.DATA_FIELD + " 3G";
          tmpData2.DATA_SUM = item.DATA_3G;
          tmpData2.DATA_SUM_str = item.DATA_3G_str;
          tmpData2Ary.push(tmpData2);

          tmpData2.DATA_FIELD = item.DATA_FIELD + " LTE";
          tmpData2.DATA_SUM = item.DATA_LTE;
          tmpData2.DATA_SUM_str = item.DATA_LTE_str;
          tmpData2Ary.push(tmpData2);

          tmpData2.DATA_FIELD = item.DATA_FIELD + " 5G";
          tmpData2.DATA_SUM = item.DATA_5G;
          tmpData2.DATA_SUM_str = item.DATA_5G_str;
          tmpData2Ary.push(tmpData2);
        }

      } else {
        for (let j = 0; j < prm_check2.length; j++) {
          tmpData['DATA_' + prm_check2[j]] = item['DATA_' + prm_check2[j]];
          tmpData['DATA_' + prm_check2[j] + '_str'] = item['DATA_' + prm_check2[j] + '_str'];

          tmpData2.DATA_FIELD = item.DATA_FIELD + " " + prm_check2[j];
          tmpData2.DATA_SUM = item['DATA_' + prm_check2[j]];
          tmpData2Ary.push(tmpData2);
        }
      }

////
      tmpData.DATA_FIELD = item.DATA_FIELD;
      tmpData.DATA_SUM_str = 100;

      if (chkCount === 1 && ((_gubun_code === "service" && _admin !== 'Y') || _gubun_code !== "service")) {
        tmpData.DATA_SUM_str = (Number(item.DATA_SUM) / _max_cnt * 100).toFixed(2);
      }
/////
      if (_gubun_code === "service") {
        for (let j = 0; j < prm_check.length; j++) {

          if (_admin === 'Y') {
            if (Number(item.DATA_SUM) > 0) {
              tmpData['DATA_' + prm_check[j] + '_LG'] =
                (Number(item['DATA_' + prm_check[j] + '_LG']) / Number(item.DATA_SUM) * 100).toFixed(2);
              tmpData['DATA_' + prm_check[j] + '_LG_str'] =
                insertComma((Number(item['DATA_' + prm_check[j] + '_LG']) / Number(item.DATA_SUM) * 100).toFixed(2));
              tmpData['DATA_' + prm_check[j] + '_KT'] =
                (Number(item['DATA_' + prm_check[j] + '_KT']) / Number(item.DATA_SUM) * 100).toFixed(2);
              tmpData['DATA_' + prm_check[j] + '_KT_str'] =
                insertComma((Number(item['DATA_' + prm_check[j] + '_KT']) / Number(item.DATA_SUM) * 100).toFixed(2));
              tmpData['DATA_' + prm_check[j] + '_SK'] =
                (Number(item['DATA_' + prm_check[j] + '_SK']) / Number(item.DATA_SUM) * 100).toFixed(2);
              tmpData['DATA_' + prm_check[j] + '_SK_str'] =
                insertComma((Number(item['DATA_' + prm_check[j] + '_SK']) / Number(item.DATA_SUM) * 100).toFixed(2));
            } else {
              tmpData['DATA_' + prm_check[j] + '_LG'] = 0;
              tmpData['DATA_' + prm_check[j] + '_KT'] = 0;
              tmpData['DATA_' + prm_check[j] + '_SK'] = 0;
              tmpData['DATA_' + prm_check[j] + '_LG_str'] = 0;
              tmpData['DATA_' + prm_check[j] + '_KT_str'] = 0;
              tmpData['DATA_' + prm_check[j] + '_SK_str'] = 0;
            }
          } else { // 일반 사용자일 경우
            if (chkCount === 1) {
              check_column = prm_check[j];
              if (_max_cnt > 0) {
                tmpData['DATA_' + prm_check[j]] =
                  (Number(item['DATA_' + prm_check[j]]) / _max_cnt * 100).toFixed(2);
                tmpData['DATA_' + prm_check[j] + '_str'] =
                  insertComma((Number(item['DATA_' + prm_check[j]]) / _max_cnt * 100).toFixed(2))
              } else {
                tmpData['DATA_' + prm_check[j]] = 0;
                tmpData['DATA_' + prm_check[j] + '_str'] = 0;
              }

            } else {

              if (Number(item.DATA_SUM) > 0) {
                tmpData['DATA_' + prm_check[j]] =
                  (Number(item['DATA_' + prm_check[j]]) / Number(item.DATA_SUM) * 100).toFixed(2);
                tmpData['DATA_' + prm_check[j] + '_str'] =
                  insertComma((Number(item['DATA_' + prm_check[j]]) / Number(item.DATA_SUM) * 100).toFixed(2))
              } else {
                tmpData['DATA_' + prm_check[j]] = 0;
                tmpData['DATA_' + prm_check[j] + '_str'] = 0;
              }

            }
          }

        }
      } else {
        for (let j = 0; j < prm_check2.length; j++) {

          if (chkCount === 1) {

            check_column = prm_check2[j];

            if (_max_cnt > 0) {
              tmpData['DATA_' + prm_check2[j]] =
                (Number(item['DATA_' + prm_check2[j]]) / _max_cnt * 100).toFixed(2);
              tmpData['DATA_' + prm_check2[j] + '_str'] =
                insertComma((Number(item['DATA_' + prm_check2[j]]) / _max_cnt * 100).toFixed(2))
            } else {
              tmpData['DATA_' + prm_check2[j]] = 0;
              tmpData['DATA_' + prm_check2[j] + '_str'] = 0;
            }

          } else {
            if (Number(item.DATA_SUM) > 0) {
              tmpData['DATA_' + prm_check2[j]] =
                (Number(item['DATA_' + prm_check2[j]]) / Number(item.DATA_SUM) * 100).toFixed(2);
              tmpData['DATA_' + prm_check2[j] + '_str'] =
                insertComma((Number(item['DATA_' + prm_check2[j]]) / Number(item.DATA_SUM) * 100).toFixed(2))
            } else {
              tmpData['DATA_' + prm_check2[j]] = 0;
              tmpData['DATA_' + prm_check2[j] + '_str'] = 0;
            }
          }

        }
      }

      chartBaseData.Data.push(tmpData);
    }
    chartBaseData.Data2 = tmpData2Ary;

    if (chkCount === 1 && check_column !== "") {

      chartBaseData.title = "지역별 무선국 점유비율(%)";

      chartBaseData.Data.sort(function (a, b) {
        return Number(a['DATA_' + check_column]) < Number(b['DATA_' + check_column]) ? -1 : Number(a['DATA_' + check_column]) > Number(b['DATA_' + check_column]) ? 1 : 0;
      });
    } else {
      if (_gubun_code === "service") {
        chartBaseData.title = "지역별서비스별 무선국 점유율(%)";
      } else {
        chartBaseData.title = "지역별국종별 무선국 점유율(%)";
      }

      chartBaseData.Data.sort(function (a, b) {
        return a['DATA_FIELD'] > b['DATA_FIELD'] ? -1 : a['DATA_FIELD'] < b['DATA_FIELD'] ? 1 : 0;
      });

    }

  }// if문 끝
  //return chartBaseData;
  const chartShareData1 = chartBaseData.Data;
  const chartShareData2 = chartBaseData.Data2;
  const chartShareTitle = chartBaseData.title;
  return {chartShareData1, chartShareData2,chartShareTitle};
}

// chart1 레이아웃 생성
/**
 * id : "chart1",
		realId : "chartHolder1",
		title : "지역별서비스별 무선국 점유율(%)",
		xtitle : "점유율(%)",
		ytitle : "지역명",
		chartType : "Multi Series Stacked Bar",
		layOutStyle : "Detail",
		masterName : "무선국 점유율",
		layOut : "",
		Data :[],
		Data2 : [],
		valueFixed : 5,
    _admin: "",
 */
export function setChartLayoutforShare (chartBaseData, {title, searchYear, _gubun_code, _admin, prm_check, prm_check2, prm_check2_label}) {

  let dataTipJsFunctionData = "";
  if (chartBaseData.valueFixed > 0) {
    if (chartBaseData.layOutStyle === 'Mater') {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc2"';
    } else {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc2_stacked_bar"';
    }
  } else {
    if (chartBaseData.layOutStyle === 'Mater') {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc0"';
    } else {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc0_stacked_bar"';
    }
  }

  let layOutData =
    '<rMateChart backgroundColor="#FFFFFF" borderStyle="none" >'
    + '<Options>'
    + '<Caption fontSize="19" text="' + title + ' "/>'
    //+'<Caption fontSize="19" text="'+chartBaseData["chart"+i].title+' &lt;a href=javascript:cartDownload(\'chart'+i+'\')&gt;&lt;img src=\'/images/chart/chartsave.png\' title=\'차트이미지저장\'&gt; &lt;/a&gt; &lt;a onclick=cartCsvDownloadcartId(\'chart'+i+'\')&gt;&lt;img  src=\'/images/chart/chart_download.png\' title=\'차트CSV저장\'&gt;&lt;/a&gt;"/>'
    + '<SubCaption textAlign="right" fontSize="15" paddingRight="10" text="(' + searchYear + '년)"/>'
    + '<Legend defaultMouseOverAction="false"  fontSize="15"/>'
    + '</Options>'
    + '<NumberFormatter id="numfmt" useThousandsSeparator="true"/>'
    + '<Bar3DChart showDataTips="true"' + dataTipJsFunctionData + '>'
    + '<horizontalAxis>'
    + '<LinearAxis formatter="{numfmt}" id="hAxis" maximum="102" title="' + chartBaseData.xtitle + '" labelJsFunction="labelFuncNum"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis3DRenderer axis="{hAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</horizontalAxisRenderers>'
    + '<verticalAxis>'
    + '<CategoryAxis id="vAxis" categoryField="DATA_FIELD" title="' + chartBaseData.ytitle + '" labelJsFunction="labelFunc"/>'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis3DRenderer axis="{vAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="false" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</verticalAxisRenderers>'
    + '<series>';
  if (_gubun_code === "service") {

    if (_admin === 'Y') {
      for (let j = 0; j < prm_check.length; j++) {
        layOutData +=
          '<Bar3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
          + '<series>'
          + '<Bar3DSeries labelPosition="inside" xField="DATA_' + prm_check[j] + '_LG" displayName="' + prm_check[j] + ' LG" styleName="seriesLabel" showValueLabels="[]">'
          + '<fill>'
          + '<SolidColor color="' + chartColor(prm_check[j] + ' LG') + '"/>'
          + '</fill>'
          + '<showDataEffect>'
          + '<SeriesInterpolate/>'
          + '</showDataEffect>'
          + '</Bar3DSeries>'
          + '<Bar3DSeries labelPosition="inside" xField="DATA_' + prm_check[j] + '_KT" displayName="' + prm_check[j] + ' KT" styleName="seriesLabel" showValueLabels="[]">'
          + '<fill>'
          + '<SolidColor color="' + chartColor(prm_check[j] + ' KT') + '"/>'
          + '</fill>'
          + '<showDataEffect>'
          + '<SeriesInterpolate/>'
          + '</showDataEffect>'
          + '</Bar3DSeries>'
          + '<Bar3DSeries labelPosition="inside" xField="DATA_' + prm_check[j] + '_SK" displayName="' + prm_check[j] + ' SK" styleName="seriesLabel" showValueLabels="[]">'
          + '<fill>'
          + '<SolidColor color="' + chartColor(prm_check[j] + ' SK') + '"/>'
          + '</fill>'
          + '<showDataEffect>'
          + '<SeriesInterpolate/>'
          + '</showDataEffect>'
          + '</Bar3DSeries>'
          + '</series>'
          + '</Bar3DSet>';
      }
    } else {
      layOutData +=
        '<Bar3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
        + '<series>';
      for (let j = 0; j < prm_check.length; j++) {
        layOutData +=
          '<Bar3DSeries labelPosition="inside" xField="DATA_' + prm_check[j] + '" displayName="' + prm_check[j] + '" styleName="seriesLabel" showValueLabels="[]">'
          + '<fill>'
          + '<SolidColor color="' + chartColor(prm_check[j]) + '"/>'
          + '</fill>'
          + '<showDataEffect>'
          + '<SeriesInterpolate/>'
          + '</showDataEffect>'
          + '</Bar3DSeries>';


      }
      layOutData +=
        '</series>'
        + '</Bar3DSet>';
    }

  } else {

    layOutData +=
      '<Bar3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
      + '<series>';
    for (let j = 0; j < prm_check2.length; j++) {
      layOutData +=
        '<Bar3DSeries labelPosition="inside" xField="DATA_' + prm_check2[j] + '" displayName="' + prm_check2_label[j] + '" styleName="seriesLabel" showValueLabels="[]">'
        + '<fill>'
        + '<SolidColor color="' + chartColor(prm_check2[j]) + '"/>'
        + '</fill>'
        + '<showDataEffect>'
        + '<SeriesInterpolate/>'
        + '</showDataEffect>'
        + '</Bar3DSeries>';
    }
    layOutData +=
      '</series>'
      + '</Bar3DSet>';
  }
  layOutData +=
    '</series>'
    + '<annotationElements>'
    + '<CrossRangeZoomer zoomType="vertical"  enableZooming="true" enableCrossHair="false">'
    + '</CrossRangeZoomer>'
    /* CrossRangeZoomer 속성 설명
      * zoomType : 줌 실행 기준을 정합니다. 유효값 : horizontal, vertical, both
      * horizontalLabelFormatter : 십자가의 수평 라인에 붙는 라벨 formatter 입니다.
      * verticalLabelFormatter : 십자가의 수직 라인에 붙는 라벨 formatter 입니다.
      * enableZooming : zoom 기능 사용 여부를 나타냅니다.
      * enableCrossHair : 십자가 표시 여부를 나타냅니다.
      * useDualCrossXLabel : 십자가의 수평 라인에 두개의 라벨을 표시합니다.(듀얼축인 경우 유효)
      * useDualCrossYLabel : 십자가의 수직 라인에 두개의 라벨을 표시합니다.(듀얼축인 경우 유효)
      * verticalLabelPlacement : 수직 라인의 라벨 위치를 지정합니다.(유효값: top, bottom)
      * horizontalLabelPlacement : 수평 라인의 라벨 위치를 지정합니다.(유효값 : left, right)
     */
    + '</annotationElements>'
    + '</Bar3DChart>'
    + '<Style>'
    + '.seriesLabel{fontSize:11;color:#ffffff;fontWeight:bold;}'
    + '.title{color : 0x4691E1;fontSize : 15;fontWeight : bold;}'
    + '</Style>'
    + '</rMateChart>';

    chartBaseData.layOut = layOutData;

  return layOutData;
}

// chart2 데이터 생성 리턴 값 : {} chartBaseData
export function dataSettingByNumber(dataList, _admin, _gubun_code) {
  // eslint-disable-next-line no-unused-vars
  let chkCount = 1; // 무슨 의미?
  let chartBaseData = {
    // id: "chart2",
    // realId: "chartHolder2",
    title: "지역별서비스별 무선국 수",
    xtitle: "지역명",
    ytitle: "무선국 수",
    chartType: "Multi Series Stacked",
    layOutStyle: "Detail",
    masterName: "무선국 수",
    layOut: "",
    Data: [],
    Data2: [],
    valueFixed: 0,
    _admin: _admin,
  };

  if (_gubun_code === 'service'){
    chartBaseData.title = "지역별 서비스별 무선국 수";
  }else {
    chartBaseData.title = "지역별 국종별 무선국 수";
  }

  // let tmpData = dataList; // item
  let _tot_cnt = 0; // 무선국 수 합계
  // let _tot_popltn = 0;
  // let _tot_cnt2 = 0; // 인구유형별서비스별 인구밀도에 따른 무선국 수 합
  let _tot_area_size = 0; // 조회대상 총 면적

  let _max_cnt = 0;

  // let check_column = "";
  // let data2 = [];

  for (let i = 0; i < dataList.length; ++i) {
    let item = dataList[i];
    switch (item.DATA_TYPE) {
      case 'DATA_TYPE2' : // 지역별서비스별(국종별) 무선국 수
        let firstTmpData = {};
        firstTmpData.DATA_FIELD = item.DATA_FIELD;
        firstTmpData.DATA_COLUMN = item.DATA_COLUMN;
        firstTmpData.DATA_SUM = Number(item.DATA_SUM).toFixed(2);
        firstTmpData.DATA_SUM_str = insertComma(item.DATA_SUM);
        _tot_cnt += Number(item.DATA_SUM);

        if (_max_cnt < Number(item.DATA_SUM)) _max_cnt = Number(item.DATA_SUM);

        firstTmpData.DATA_2G = item.DATA_2G;
        firstTmpData.DATA_2G_str = insertComma(item.DATA_2G);
        firstTmpData.DATA_3G = item.DATA_3G;
        firstTmpData.DATA_3G_str = insertComma(item.DATA_3G);
        firstTmpData.DATA_LTE = item.DATA_LTE;
        firstTmpData.DATA_LTE_str = insertComma(item.DATA_LTE);
        firstTmpData.DATA_5G = item.DATA_5G;
        firstTmpData.DATA_5G_str = insertComma(item.DATA_5G);
        if (_gubun_code === "service") {
          if (_admin === 'Y') {
            firstTmpData.DATA_2G_LG = item.DATA_2G_LG;
            firstTmpData.DATA_2G_LG_str = insertComma(item.DATA_2G_LG);
            firstTmpData.DATA_3G_LG = item.DATA_3G_LG;
            firstTmpData.DATA_3G_LG_str = insertComma(item.DATA_3G_LG);
            firstTmpData.DATA_LTE_LG = item.DATA_LTE_LG;
            firstTmpData.DATA_LTE_LG_str = insertComma(item.DATA_LTE_LG);
            firstTmpData.DATA_5G_LG = item.DATA_5G_LG;
            firstTmpData.DATA_5G_LG_str = insertComma(item.DATA_5G_LG);

            firstTmpData.DATA_2G_KT = item.DATA_2G_KT;
            firstTmpData.DATA_2G_KT_str = insertComma(item.DATA_2G_KT);
            firstTmpData.DATA_3G_KT = item.DATA_3G_KT;
            firstTmpData.DATA_3G_KT_str = insertComma(item.DATA_3G_KT);
            firstTmpData.DATA_LTE_KT = item.DATA_LTE_KT;
            firstTmpData.DATA_LTE_KT_str = insertComma(item.DATA_LTE_KT);
            firstTmpData.DATA_5G_KT = item.DATA_5G_KT;
            firstTmpData.DATA_5G_KT_str = insertComma(item.DATA_5G_KT);

            firstTmpData.DATA_2G_SK = item.DATA_2G_SK;
            firstTmpData.DATA_2G_SK_str = insertComma(item.DATA_2G_SK);
            firstTmpData.DATA_3G_SK = item.DATA_3G_SK;
            firstTmpData.DATA_3G_SK_str = insertComma(item.DATA_3G_SK);
            firstTmpData.DATA_LTE_SK = item.DATA_LTE_SK;
            firstTmpData.DATA_LTE_SK_str = insertComma(item.DATA_LTE_SK);
            firstTmpData.DATA_5G_SK = item.DATA_5G_SK;
            firstTmpData.DATA_5G_SK_str = insertComma(item.DATA_5G_SK);

          }
        } else {
          firstTmpData.DATA_32 = item.DATA_32;
          firstTmpData.DATA_32_str = insertComma(item.DATA_32);
          firstTmpData.DATA_94 = item.DATA_94;
          firstTmpData.DATA_94_str = insertComma(item.DATA_94);
          firstTmpData.DATA_44 = item.DATA_44;
          firstTmpData.DATA_44_str = insertComma(item.DATA_44);
          firstTmpData.DATA_85 = item.DATA_85;
          firstTmpData.DATA_85_str = insertComma(item.DATA_85);
          firstTmpData.DATA_49 = item.DATA_49;
          firstTmpData.DATA_49_str = insertComma(item.DATA_49);
          firstTmpData.DATA_92 = item.DATA_92;
          firstTmpData.DATA_92_str = insertComma(item.DATA_92);
          firstTmpData.DATA_42 = item.DATA_42;
          firstTmpData.DATA_42_str = insertComma(item.DATA_42);
          firstTmpData.DATA_41 = item.DATA_41;
          firstTmpData.DATA_41_str = insertComma(item.DATA_41);
          firstTmpData.DATA_21 = item.DATA_21;
          firstTmpData.DATA_21_str = insertComma(item.DATA_21);
          firstTmpData.DATA_CMFL = item.DATA_CMFL;
          firstTmpData.DATA_CMFL_str = insertComma(item.DATA_CMFL);
          firstTmpData.DATA_OTHER = item.DATA_OTHER;
          firstTmpData.DATA_OTHER_str = insertComma(item.DATA_OTHER);
        }
        chartBaseData.Data.push(firstTmpData);
        break;
      case 'DATA_TYPE4' : // 지역전체면적
        _tot_area_size = Number(item.DATA_SUM);
        break;
      // no default
    }
  }

  if (chartBaseData.Data.length > 0) {
    chartBaseData.Data.sort(function (a, b) {
      return b.DATA_SUM - a.DATA_SUM;
    });
  }
  // return chartBaseData;
  const chartNumberData1 = chartBaseData.Data;
  const chartNumberData2 = chartBaseData.Data2;
  const chartNumberTitle = chartBaseData.title;
  return {chartNumberData1, chartNumberData2,chartNumberTitle};
}

// chart2 레이아웃 생성
/**
 * id : "chart2",
		realId : "chartHolder2",
		title :"지역별서비스별 무선국 수",
		xtitle : "지역명",
		ytitle : "무선국 수",
		chartType : "Multi Series Stacked",
		layOutStyle : "Detail",
		masterName : "무선국 수",
		layOut : "",
		Data : [],
		Data2 : [],
		valueFixed : 0,
    _admin: "",
 */
export function setChartLayoutforNumber (chartBaseData, {title,searchYear, _gubun_code, _admin, prm_check, prm_check2, prm_check2_label}) {
  let dataTipJsFunctionData = "";
  if (chartBaseData.valueFixed > 0) {
    if (chartBaseData.layOutStyle === 'Mater') {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc2"';
    } else {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc2_stacked"';
    }
  } else {
    if (chartBaseData.layOutStyle === 'Mater') {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc0"';
    } else {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc0_stacked"';
    }
  }
  let layOutData =
    '<rMateChart backgroundColor="#FFFFFF" borderStyle="none" >'
    + '<Options>'
    + '<Caption fontSize="19" text="' + title + '  "/>'
    //+'<Caption fontSize="19" text="'+chartBaseData["chart"+i].title+' &lt;a href=javascript:cartDownload(\'chart'+i+'\')&gt;&lt;img src=\'/images/chart/chartsave.png\' title=\'차트이미지저장\'&gt; &lt;/a&gt; &lt;a onclick=cartCsvDownloadcartId(\'chart'+i+'\')&gt;&lt;img  src=\'/images/chart/chart_download.png\' title=\'차트CSV저장\'&gt;&lt;/a&gt; "/>'
    + '<SubCaption textAlign="right" fontSize="15" paddingRight="10" text="(' + searchYear + '년)"/>'
    + '<Legend defaultMouseOverAction="false"  fontSize="15"/>'
    + '</Options>'
    + '<NumberFormatter id="numfmt" useThousandsSeparator="true"/>'
    + '<Column3DChart showDataTips="true"' + dataTipJsFunctionData + '>'
    + '<horizontalAxis>'
    + '<CategoryAxis id="hAxis" categoryField="DATA_FIELD" title="' + chartBaseData.xtitle + '" labelJsFunction="labelFunc2"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis3DRenderer axis="{hAxis}" axisTitleStyleName="title" labelRotation="45" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</horizontalAxisRenderers>'
    + '<verticalAxis>'
    + '<LinearAxis formatter="{numfmt}" id="vAxis" title="' + chartBaseData.ytitle + '" labelJsFunction="labelFuncNum"/>'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis3DRenderer axis="{vAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</verticalAxisRenderers>'
    + '<series>';
  if (_gubun_code === 'service') {

    if (_admin === 'Y') {

      for (let j = 0; j < prm_check.length; j++) {

        layOutData +=
          '<Column3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
          + '<series>'
          + '<Column3DSeries labelPosition="inside" yField="DATA_' + prm_check[j] + '_LG" displayName="' + prm_check[j] + ' LG" styleName="seriesLabel" showValueLabels="[]">'
          + '<fill>'
          + '<SolidColor color="' + chartColor(prm_check[j] + ' LG') + '"/>'
          + '</fill>'
          + '<showDataEffect>'
          + '<SeriesInterpolate/>'
          + '</showDataEffect>'
          + '</Column3DSeries>'
          + '<Column3DSeries labelPosition="inside" yField="DATA_' + prm_check[j] + '_KT" displayName="' + prm_check[j] + ' KT" styleName="seriesLabel" showValueLabels="[]">'
          + '<fill>'
          + '<SolidColor color="' + chartColor(prm_check[j] + ' KT') + '"/>'
          + '</fill>'
          + '<showDataEffect>'
          + '<SeriesInterpolate/>'
          + '</showDataEffect>'
          + '</Column3DSeries>'
          + '<Column3DSeries labelPosition="inside" yField="DATA_' + prm_check[j] + '_SK" displayName="' + prm_check[j] + ' SK" styleName="seriesLabel" showValueLabels="[]">'
          + '<fill>'
          + '<SolidColor color="' + chartColor(prm_check[j] + ' SK') + '"/>'
          + '</fill>'
          + '<showDataEffect>'
          + '<SeriesInterpolate/>'
          + '</showDataEffect>'
          + '</Column3DSeries>'
          + '</series>'
          + '</Column3DSet>';
      }
    } else {

      layOutData +=
        '<Column3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
        + '<series>';
      for (let j = 0; j < prm_check.length; j++) {


        layOutData +=
          '<Column3DSeries labelPosition="inside" yField="DATA_' + prm_check[j] + '" displayName="' + prm_check[j] + '" styleName="seriesLabel" showValueLabels="[]">'
          + '<fill>'
          + '<SolidColor color="' + chartColor(prm_check[j]) + '"/>'
          + '</fill>'
          + '<showDataEffect>'
          + '<SeriesInterpolate/>'
          + '</showDataEffect>'
          + '</Column3DSeries>'

      }
      layOutData +=
        '</series>'
        + '</Column3DSet>';
    }

  } else {

    layOutData +=
      '<Column3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
      + '<series>';
    for (let j = 0; j < prm_check2.length; j++) {


      layOutData +=
        '<Column3DSeries labelPosition="inside" yField="DATA_' + prm_check2[j] + '" displayName="' + prm_check2_label[j] + '" styleName="seriesLabel" showValueLabels="[]">'
        + '<fill>'
        + '<SolidColor color="' + chartColor(prm_check2[j]) + '"/>'
        + '</fill>'
        + '<showDataEffect>'
        + '<SeriesInterpolate/>'
        + '</showDataEffect>'
        + '</Column3DSeries>';


    }
    layOutData +=
      '</series>'
      + '</Column3DSet>';

  }
  layOutData +=
    '</series>'
    + '<annotationElements>'
    + '<CrossRangeZoomer zoomType="horizontal"  enableZooming="true" enableCrossHair="false">'
    + '</CrossRangeZoomer>'
    /* CrossRangeZoomer 속성 설명
* zoomType : 줌 실행 기준을 정합니다. 유효값 : horizontal, vertical, both
* horizontalLabelFormatter : 십자가의 수평 라인에 붙는 라벨 formatter 입니다.
* verticalLabelFormatter : 십자가의 수직 라인에 붙는 라벨 formatter 입니다.
* enableZooming : zoom 기능 사용 여부를 나타냅니다.
* enableCrossHair : 십자가 표시 여부를 나타냅니다.
* useDualCrossXLabel : 십자가의 수평 라인에 두개의 라벨을 표시합니다.(듀얼축인 경우 유효)
* useDualCrossYLabel : 십자가의 수직 라인에 두개의 라벨을 표시합니다.(듀얼축인 경우 유효)
* verticalLabelPlacement : 수직 라인의 라벨 위치를 지정합니다.(유효값: top, bottom)
* horizontalLabelPlacement : 수평 라인의 라벨 위치를 지정합니다.(유효값 : left, right)
*/
    + '</annotationElements>'
    + '</Column3DChart>'
    + '<Style>'
    + '.seriesLabel{fontSize:11;color:#ffffff;fontWeight:bold;}'
    + '.title{color : 0x4691E1;fontSize : 15;fontWeight : bold;}'
    + '</Style>'
    + '</rMateChart>';
  // chartBaseData.layOut = layOutData;

  return layOutData;
}

// chart3 데이터 생성 리턴 값 : {} chartBaseData
export function dataSettingByDensity (dataList, _admin, _gubun_code, prm_check2) {
  let chkCount = 1; // 무슨 의미?
  let chartBaseData = {
    // id: "chart3",
    // realId: "chartHolder3",
    title: "지역별서비스별 무선국 밀도(국수/㎢)",
    xtitle: "지역명",
    ytitle: "무선국 밀도(국수/㎢)",
    chartType: "Multi Series Stacked",
    layOutStyle: "Detail",
    masterName: "무선국 밀도",
    layOut: "",
    Data: [],
    Data2: [],
    valueFixed: 5,
    _admin: _admin,
  };
  if (_gubun_code === 'service'){
    chartBaseData.title = "지역별 서비스별 무선국 밀도(국수/㎢)";
  }else {
    chartBaseData.title = "지역별 국종별 무선국 밀도(국수/㎢)";
    chkCount = prm_check2.length;
  }
  let tmpData = dataList; // item
  // let _tot_cnt = 0; // 무선국 수 합계
  // let _tot_popltn = 0;
  // let _tot_cnt2 = 0; // 인구유형별서비스별 인구밀도에 따른 무선국 수 합
  let _tot_area_size = 0; // 조회대상 총 면적

  // let _max_cnt = 0;

  // let check_column = "";
  // let data2 = [];

  for (let i = 0; i < dataList.length; ++i) {
    let item = dataList[i];
    switch (item.DATA_TYPE) {
      case 'DATA_TYPE3' : // 지역별서비스별(국종별) 무선국 밀도
        let tmpData = {};
        tmpData.DATA_FIELD = item.DATA_FIELD;
        tmpData.DATA_COLUMN = item.DATA_COLUMN;
        tmpData.DATA_SUM = Number(item.DATA_SUM).toFixed(2);
        tmpData.DATA_SUM_str = insertComma(Number(item.DATA_SUM).toFixed(2));
        tmpData.DATA_2G = item.DATA_2G;
        tmpData.DATA_2G_str = insertComma(Number(item.DATA_2G).toFixed(2));
        tmpData.DATA_3G = item.DATA_3G;
        tmpData.DATA_3G_str = insertComma(Number(item.DATA_3G).toFixed(2));
        tmpData.DATA_LTE = item.DATA_LTE;
        tmpData.DATA_LTE_str = insertComma(Number(item.DATA_LTE).toFixed(2));
        tmpData.DATA_5G = item.DATA_5G;
        tmpData.DATA_5G_str = insertComma(Number(item.DATA_5G).toFixed(2));
        if (_gubun_code === "service") {
          if (_admin === 'Y') {
            tmpData.DATA_2G_LG = item.DATA_2G_LG;
            tmpData.DATA_2G_LG_str = insertComma(Number(item.DATA_2G_LG).toFixed(2));
            tmpData.DATA_3G_LG = item.DATA_3G_LG;
            tmpData.DATA_3G_LG_str = insertComma(Number(item.DATA_3G_LG).toFixed(2));
            tmpData.DATA_LTE_LG = item.DATA_LTE_LG;
            tmpData.DATA_LTE_LG_str = insertComma(Number(item.DATA_LTE_LG).toFixed(2));
            tmpData.DATA_5G_LG = item.DATA_5G_LG;
            tmpData.DATA_5G_LG_str = insertComma(Number(item.DATA_5G_LG).toFixed(2));

            tmpData.DATA_2G_KT = item.DATA_2G_KT;
            tmpData.DATA_2G_KT_str = insertComma(Number(item.DATA_2G_KT).toFixed(2));
            tmpData.DATA_3G_KT = item.DATA_3G_KT;
            tmpData.DATA_3G_KT_str = insertComma(Number(item.DATA_3G_KT).toFixed(2));
            tmpData.DATA_LTE_KT = item.DATA_LTE_KT;
            tmpData.DATA_LTE_KT_str = insertComma(Number(item.DATA_LTE_KT).toFixed(2));
            tmpData.DATA_5G_KT = item.DATA_5G_KT;
            tmpData.DATA_5G_KT_str = insertComma(Number(item.DATA_5G_KT).toFixed(2));

            tmpData.DATA_2G_SK = item.DATA_2G_SK;
            tmpData.DATA_2G_SK_str = insertComma(Number(item.DATA_2G_SK).toFixed(2));
            tmpData.DATA_3G_SK = item.DATA_3G_SK;
            tmpData.DATA_3G_SK_str = insertComma(Number(item.DATA_3G_SK).toFixed(2));
            tmpData.DATA_LTE_SK = item.DATA_LTE_SK;
            tmpData.DATA_LTE_SK_str = insertComma(Number(item.DATA_LTE_SK).toFixed(2));
            tmpData.DATA_5G_SK = item.DATA_5G_SK;
            tmpData.DATA_5G_SK_str = insertComma(Number(item.DATA_5G_SK).toFixed(2));

          }
        } else {
          tmpData.DATA_32 = item.DATA_32;
          tmpData.DATA_32_str = insertComma(Number(item.DATA_32).toFixed(2));
          tmpData.DATA_94 = item.DATA_94;
          tmpData.DATA_94_str = insertComma(Number(item.DATA_94).toFixed(2));
          tmpData.DATA_44 = item.DATA_44;
          tmpData.DATA_44_str = insertComma(Number(item.DATA_44).toFixed(2));
          tmpData.DATA_85 = item.DATA_85;
          tmpData.DATA_85_str = insertComma(Number(item.DATA_85).toFixed(2));
          tmpData.DATA_49 = item.DATA_49;
          tmpData.DATA_49_str = insertComma(Number(item.DATA_49).toFixed(2));
          tmpData.DATA_92 = item.DATA_92;
          tmpData.DATA_92_str = insertComma(Number(item.DATA_92).toFixed(2));
          tmpData.DATA_42 = item.DATA_42;
          tmpData.DATA_42_str = insertComma(Number(item.DATA_42).toFixed(2));
          tmpData.DATA_41 = item.DATA_41;
          tmpData.DATA_41_str = insertComma(Number(item.DATA_41).toFixed(2));
          tmpData.DATA_21 = item.DATA_21;
          tmpData.DATA_21_str = insertComma(Number(item.DATA_21).toFixed(2));
          tmpData.DATA_CMFL = item.DATA_CMFL;
          tmpData.DATA_CMFL_str = insertComma(Number(item.DATA_CMFL).toFixed(2));
          tmpData.DATA_OTHER = item.DATA_OTHER;
          tmpData.DATA_OTHER_str = insertComma(Number(item.DATA_OTHER).toFixed(2));
        }
        chartBaseData.Data.push(tmpData);
        break;
      case 'DATA_TYPE4' : // 지역전체면적
        _tot_area_size = Number(item.DATA_SUM);
        break;
      // no default
    }
  }  // for 문 끝

  if ( chartBaseData.Data.length > 0) {
    let tmpData2Ary = [];

    for (var i = 0; i < chartBaseData.Data2.length; i++) {
      let item = chartBaseData.Data2[i];

      let tmpData2 = {};
      if (_gubun_code === "service") {
          if (_admin === 'Y') {
            tmpData2.DATA_FIELD = item.DATA_FIELD + " 2G LG";
            tmpData2.DATA_SUM = item.DATA_2G_LG;
            tmpData2.DATA_SUM_str = item.DATA_2G_LG_str;
            tmpData2Ary.push(tmpData2);

            tmpData2.DATA_FIELD = item.DATA_FIELD + " 2G KT";
            tmpData2.DATA_SUM = item.DATA_2G_KT;
            tmpData2.DATA_SUM_str = item.DATA_2G_KT_str;
            tmpData2Ary.push(tmpData2);

            tmpData2.DATA_FIELD = item.DATA_FIELD + " 2G SK";
            tmpData2.DATA_SUM = item.DATA_2G_SK;
            tmpData2.DATA_SUMT_str = item.DATA_2G_SKT_str;
            tmpData2Ary.push(tmpData2);

            tmpData2.DATA_FIELD = item.DATA_FIELD + " 3G LG";
            tmpData2.DATA_SUM = item.DATA_3G_LG;
            tmpData2.DATA_SUM_str = item.DATA_3G_LG_str;
            tmpData2Ary.push(tmpData2);

            tmpData2.DATA_FIELD = item.DATA_FIELD + " 3G KT";
            tmpData2.DATA_SUM = item.DATA_3G_KT;
            tmpData2.DATA_SUM_str = item.DATA_3G_KT_str;
            tmpData2Ary.push(tmpData2);

            tmpData2.DATA_FIELD = item.DATA_FIELD + " 3G SK";
            tmpData2.DATA_SUM = item.DATA_3G_SK;
            tmpData2.DATA_SUM_str = item.DATA_3G_SK_str;
            tmpData2Ary.push(tmpData2);

            tmpData2.DATA_FIELD = item.DATA_FIELD + " LTE LG";
            tmpData2.DATA_SUM = item.DATA_LTE_LG;
            tmpData2.DATA_SUM_str = item.DATA_LTE_LG_str;
            tmpData2Ary.push(tmpData2);

            tmpData2.DATA_FIELD = item.DATA_FIELD + " LTE KT";
            tmpData2.DATA_SUM = item.DATA_LTE_KT;
            tmpData2.DATA_SUM_str = item.DATA_LTE_KT_str;
            tmpData2Ary.push(tmpData2);

            tmpData2.DATA_FIELD = item.DATA_FIELD + " LTE SK";
            tmpData2.DATA_SUM = item.DATA_LTE_SK;
            tmpData2.DATA_SUM_str = item.DATA_LTE_SK_str;
            tmpData2Ary.push(tmpData2);

            tmpData2.DATA_FIELD = item.DATA_FIELD + " 5G LG";
            tmpData2.DATA_SUM = item.DATA_5G_LG;
            tmpData2.DATA_SUM_str = item.DATA_5G_LG_str;
            tmpData2Ary.push(tmpData2);

            tmpData2.DATA_FIELD = item.DATA_FIELD + " 5G KT";
            tmpData2.DATA_SUM = item.DATA_5G_KT;
            tmpData2.DATA_SUM_str = item.DATA_5G_KT_str;
            tmpData2Ary.push(tmpData2);

            tmpData2.DATA_FIELD = item.DATA_FIELD + " 5G SK";
            tmpData2.DATA_SUM = item.DATA_5G_SK;
            tmpData2.DATA_SUM_str = item.DATA_5G_SK_str;
            tmpData2Ary.push(tmpData2);

          } else {
            tmpData2.DATA_FIELD = item.DATA_FIELD + " 2G";
            tmpData2.DATA_SUM = item.DATA_2G;
            tmpData2.DATA_SUM_str = item.DATA_2G_str;
            tmpData2Ary.push(tmpData2);

            tmpData2.DATA_FIELD = item.DATA_FIELD + " 3G";
            tmpData2.DATA_SUM = item.DATA_3G;
            tmpData2.DATA_SUM_str = item.DATA_3G_str;
            tmpData2Ary.push(tmpData2);

            tmpData2.DATA_FIELD = item.DATA_FIELD + " LTE";
            tmpData2.DATA_SUM = item.DATA_LTE;
            tmpData2.DATA_SUM_str = item.DATA_LTE_str;
            tmpData2Ary.push(tmpData2);

            tmpData2.DATA_FIELD = item.DATA_FIELD + " 5G";
            tmpData2.DATA_SUM = item.DATA_5G;
            tmpData2.DATA_SUM_str = item.DATA_5G_str;
            tmpData2Ary.push(tmpData2);

          }
        } else {
          for (let j = 0; j < prm_check2.length; j++) {
            tmpData['DATA_' + prm_check2[j]] = item['DATA_' + prm_check2[j]];
            tmpData['DATA_' + prm_check2[j] + '_str'] = item['DATA_' + prm_check2[j] + '_str'];

            tmpData2.DATA_FIELD = item.DATA_FIELD + " " + prm_check2[j];
            tmpData2.DATA_SUM = item['DATA_' + prm_check2[j]];
            tmpData2Ary.push(tmpData2);
          }
        }
    }// for문 끝
    chartBaseData.Data2 = tmpData2Ary;

    if (chartBaseData.Data.length > 0) {
      chartBaseData.Data.sort(function (a, b) {
        return b.DATA_SUM - a.DATA_SUM;
      });
    }
  }// if문 끝
  //return chartBaseData;
  const chartDensityData1 = chartBaseData.Data;
  const chartDensityData2 = chartBaseData.Data2;
  const chartDensityTitle = chartBaseData.title;
  return {chartDensityData1, chartDensityData2,chartDensityTitle};
}

// chart3 레이아웃 생성
/**
 * id: "chart3",
    realId: "chartHolder3",
    title: "지역별서비스별 무선국 밀도(국수/㎢)",
    xtitle: "지역명",
    ytitle: "무선국 밀도(국수/㎢)",
    chartType: "Multi Series Stacked",
    layOutStyle: "Detail",
    masterName: "무선국 밀도",
    layOut: "",
    Data: [],
    Data2: [],
    valueFixed: 5,
    _admin: "",
 */
export function setChartLayoutforDensity (chartBaseData, {title, searchYear, _gubun_code, _admin, prm_check, prm_check2, prm_check2_label}){
  let dataTipJsFunctionData = "";
  if (chartBaseData.valueFixed > 0) {
    if (chartBaseData.layOutStyle === 'Mater') {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc2"';
    } else {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc2_stacked"';
    }
  } else {
    if (chartBaseData.layOutStyle === 'Mater') {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc0"';
    } else {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc0_stacked"';
    }
  }
  let layOutData =
    '<rMateChart backgroundColor="#FFFFFF" borderStyle="none" >'
    + '<Options>'
    + '<Caption fontSize="19" text="' + title + '  "/>'
    //+'<Caption fontSize="19" text="'+chartBaseData["chart"+i].title+' &lt;a href=javascript:cartDownload(\'chart'+i+'\')&gt;&lt;img src=\'/images/chart/chartsave.png\' title=\'차트이미지저장\'&gt; &lt;/a&gt; &lt;a onclick=cartCsvDownloadcartId(\'chart'+i+'\')&gt;&lt;img  src=\'/images/chart/chart_download.png\' title=\'차트CSV저장\'&gt;&lt;/a&gt; "/>'
    + '<SubCaption textAlign="right" fontSize="15" paddingRight="10" text="(' + searchYear + '년)"/>'
    + '<Legend defaultMouseOverAction="false"  fontSize="15"/>'
    + '</Options>'
    + '<NumberFormatter id="numfmt" useThousandsSeparator="true"/>'
    + '<Column3DChart showDataTips="true"' + dataTipJsFunctionData + '>'
    + '<horizontalAxis>'
    + '<CategoryAxis id="hAxis" categoryField="DATA_FIELD" title="' + chartBaseData.xtitle + '" labelJsFunction="labelFunc2"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis3DRenderer axis="{hAxis}" axisTitleStyleName="title" labelRotation="45" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</horizontalAxisRenderers>'
    + '<verticalAxis>'
    + '<LinearAxis formatter="{numfmt}" id="vAxis" title="' + chartBaseData.ytitle + '" labelJsFunction="labelFuncNum"/>'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis3DRenderer axis="{vAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</verticalAxisRenderers>'
    + '<series>';
  if (_gubun_code === 'service') {

    if (_admin === 'Y') {

      for (let j = 0; j < prm_check.length; j++) {

        layOutData +=
          '<Column3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
          + '<series>'
          + '<Column3DSeries labelPosition="inside" yField="DATA_' + prm_check[j] + '_LG" displayName="' + prm_check[j] + ' LG" styleName="seriesLabel" showValueLabels="[]">'
          + '<fill>'
          + '<SolidColor color="' + chartColor(prm_check[j] + ' LG') + '"/>'
          + '</fill>'
          + '<showDataEffect>'
          + '<SeriesInterpolate/>'
          + '</showDataEffect>'
          + '</Column3DSeries>'
          + '<Column3DSeries labelPosition="inside" yField="DATA_' + prm_check[j] + '_KT" displayName="' + prm_check[j] + ' KT" styleName="seriesLabel" showValueLabels="[]">'
          + '<fill>'
          + '<SolidColor color="' + chartColor(prm_check[j] + ' KT') + '"/>'
          + '</fill>'
          + '<showDataEffect>'
          + '<SeriesInterpolate/>'
          + '</showDataEffect>'
          + '</Column3DSeries>'
          + '<Column3DSeries labelPosition="inside" yField="DATA_' + prm_check[j] + '_SK" displayName="' + prm_check[j] + ' SK" styleName="seriesLabel" showValueLabels="[]">'
          + '<fill>'
          + '<SolidColor color="' + chartColor(prm_check[j] + ' SK') + '"/>'
          + '</fill>'
          + '<showDataEffect>'
          + '<SeriesInterpolate/>'
          + '</showDataEffect>'
          + '</Column3DSeries>'
          + '</series>'
          + '</Column3DSet>';
      }
    } else {

      layOutData +=
        '<Column3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
        + '<series>';
      for (let j = 0; j < prm_check.length; j++) {


        layOutData +=
          '<Column3DSeries labelPosition="inside" yField="DATA_' + prm_check[j] + '" displayName="' + prm_check[j] + '" styleName="seriesLabel" showValueLabels="[]">'
          + '<fill>'
          + '<SolidColor color="' + chartColor(prm_check[j]) + '"/>'
          + '</fill>'
          + '<showDataEffect>'
          + '<SeriesInterpolate/>'
          + '</showDataEffect>'
          + '</Column3DSeries>';

      }
      layOutData +=
        '</series>'
        + '</Column3DSet>';
    }

  } else {

    layOutData +=
      '<Column3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
      + '<series>';
    for (let j = 0; j < prm_check2.length; j++) {


      layOutData +=
        '<Column3DSeries labelPosition="inside" yField="DATA_' + prm_check2[j] + '" displayName="' + prm_check2_label[j] + '" styleName="seriesLabel" showValueLabels="[]">'
        + '<fill>'
        + '<SolidColor color="' + chartColor(prm_check2[j]) + '"/>'
        + '</fill>'
        + '<showDataEffect>'
        + '<SeriesInterpolate/>'
        + '</showDataEffect>'
        + '</Column3DSeries>';


    }
    layOutData +=
      '</series>'
      + '</Column3DSet>';

  }
  layOutData +=
    '</series>'
    + '<annotationElements>'
    + '<CrossRangeZoomer zoomType="horizontal"  enableZooming="true" enableCrossHair="false">'
    + '</CrossRangeZoomer>'
    /* CrossRangeZoomer 속성 설명
* zoomType : 줌 실행 기준을 정합니다. 유효값 : horizontal, vertical, both
* horizontalLabelFormatter : 십자가의 수평 라인에 붙는 라벨 formatter 입니다.
* verticalLabelFormatter : 십자가의 수직 라인에 붙는 라벨 formatter 입니다.
* enableZooming : zoom 기능 사용 여부를 나타냅니다.
* enableCrossHair : 십자가 표시 여부를 나타냅니다.
* useDualCrossXLabel : 십자가의 수평 라인에 두개의 라벨을 표시합니다.(듀얼축인 경우 유효)
* useDualCrossYLabel : 십자가의 수직 라인에 두개의 라벨을 표시합니다.(듀얼축인 경우 유효)
* verticalLabelPlacement : 수직 라인의 라벨 위치를 지정합니다.(유효값: top, bottom)
* horizontalLabelPlacement : 수평 라인의 라벨 위치를 지정합니다.(유효값 : left, right)
*/
    + '</annotationElements>'
    + '</Column3DChart>'
    + '<Style>'
    + '.seriesLabel{fontSize:11;color:#ffffff;fontWeight:bold;}'
    + '.title{color : 0x4691E1;fontSize : 15;fontWeight : bold;}'
    + '</Style>'
    + '</rMateChart>';
  chartBaseData.layOut = layOutData;

  return layOutData;
}




window.labelFunc = function(index, value) {
  return '<font size="15">' + value + '</font>';
  return "";
};

window.labelFuncNum = function(index, value) {
  return '<font size="15">' + window.insertComma(value) + '</font>';
  return "";
};

window.totalFunc = function (index, data, value) {
  if ( index === 3 )
    return window.insertComma(value);
  return "";
};

//숫자에 천단위 콤마 찍어 반환하는 함수.
window.insertComma = function(n) {
  var reg = /(^[+-]?\d+)(\d{3})/; // 정규식
  n += "";
  while (reg.test(n))
    n = n.replace(reg, '$1' + "," + '$2');
  return n;
};


window.dataTipFunc0_image = function(seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>무선국 밀도</b> : " + window.insertComma(Number(values[1])) + "</font>";

};

window.dataTipFunc2_image = function(seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>무선국 밀도</b> : " + window.insertComma(Number(values[1]).toFixed(2)) + "</font>";
};

window.dataTipFunc0 = function(seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>" + values[0] + "</b> : " + window.insertComma(Number(values[1])) + "</font>";

};

window.dataTipFunc2 = function(seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><font style='font-size:15px;'><b>" + values[0] + "</b> : " + window.insertComma(Number(values[1]).toFixed(2)) + "</font>";
};

window.dataTipFunc0_stacked = function(seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>" + values[0] + "</b>"
    + "<br/>" + seriesName + " : " + window.insertComma(Number(values[1])) + "</font>";

};

window.dataTipFunc2_stacked = function(seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>" + values[0] + "</b>"
    + "<br/>" + seriesName + " : " + window.insertComma(Number(values[1]).toFixed(2)) + "</font>";

};

window.dataTipFunc2_Pie = function(seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'>" + data.DATA_FIELD + " : <b>" + data.DATA_SUM_str
    + ", " + window.insertComma(Number(values[1]).toFixed(2)) + "%</b>" + "</font>";
};

window.dataTipFunc0_stacked_bar=function(seriesId, seriesName, index, xName, yName, data, values) {
  return "<b>" + values[1] + "</b>"
    + "<br/>" + seriesName + " : " + insertComma(Number(values[0])) + " %";

};

window.dataTipFunc2_stacked_bar=function(seriesId, seriesName, index, xName, yName, data, values) {
  return "<b>" + values[1] + "</b>"
    + "<br/>" + seriesName + " : " + insertComma(Number(values[0]).toFixed(2)) + " %";

};